import i18n from '@src/common/lib/i18n'
import utils from '@src/common/utils'
export const tableOption = function () {
  return {
    add: '新增',
    edit: '修改',
    view: '查看',
    page: true,
    selection: false,
    index: true,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: true,
    labelSuffix: '：',
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '100px',
    labelPosition: 'right',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 350,
    dialogWidth: '640px',
    emptyText: '暂无数据',
    menu: false,
    column: [{
        label: '车牌号码',
        prop: 'enterCarNum',
        search: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: 'center',
      },
      {
        label: '用户部门',
        prop: 'deptName',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        hide: false,
        align: 'center'
      },
      {
        label: '入场道闸名称',
        prop: 'enterSluiceDevChnname',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        hide: true,
        align: 'center'
      },
      {
        label: '车主姓名',
        prop: 'ownerName',
        search: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        hide: false,
        align: 'center',
        formatter: function (row, value) {
          return value ? value: '暂无'
        }
      },
      {
        label: '车主编号',
        prop: 'name',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        hide: true,
        align: 'center',
      },
      {
        label: '所属部门',
        prop: 'name',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        hide: true,
        align: 'center',
      },
      {
        label: '停车场名称',
        prop: 'parkingLot',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        hide: false,
        align: 'center',
      },
      {
        label: 'ETC用户',
        prop: 'etcType',
        search: false,
        searchSlot: false,
        type: 'select',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        hide: true,
        align: 'center',
        formatter: function (row, value) {
          return value == 0 ? '否': value == 1 ? '是': '暂无'
        }
      },
      {
        label: '出入场类型',
        prop: 'carStatus',
        search: true,
        type: 'select',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: 'center',
        dicData: [{
          label: '入场',
          value: '0'
        }, {
          label: '出场',
          value: '1'
        }, {
          label: '只有出场',
          value: '2'
        }, {
          label: '强制出场',
          value: '3'
        }],
        formatter: function (row, value) {
          return value == 0 ? '入场' : value == 1 ? '出场': value == 2 ? '只有出场': '强制出场'
        }
      },
      {
        label: '车辆类型',
        prop: 'carType',
        search: true,
        searchSlot: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: 'center',
        hide: false,
        formatter: function (row, value) {
          return value == 0 ? '外部车': value == 1 ? '内部车': '暂无'
        }
      },
      {
        label: '入场时间',
        prop: 'enterTime',
        search: true,
        overHidden: true,
        addDisplay: false,
        editDisplay: false,
        type: 'datetimerange',
        viewDisplay: false,
        align: 'right',
        // hide: true,
        span: 24,
        formatter: function (row, value) {
          return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
        }
      },
      {
        label: '出场时间',
        prop: 'exitTime',
        search: true,
        overHidden: true,
        addDisplay: false,
        editDisplay: false,
        type: 'datetimerange',
        viewDisplay: false,
        align: 'right',
        // hide: true,
        span: 24,
        formatter: function (row, value) {
          return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
        }
      },
      {
        label: '入场图片',
        prop: 'realCapturePicPathEnter',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        formslot: true,
        viewslot: true,
        hide: true,
        align: 'center',
      },
      {
        label: '出场图片',
        prop: 'realCapturePicPathExit',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        formslot: true,
        viewslot: true,
        hide: true,
        align: 'center',
      },

    ]
  }
}
